<template>
  <div class="config_switch">
    <div class="switch_tip">
      <h2 v-text="title" />
      <p v-text="content" />
    </div>
    <div class="switch_main">
      <self-switch
        :value="value"
        :disabled="disabled"
        @change="onChange"
      />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import selfSwitch from './Switch'
export default {
  components: {
    selfSwitch
  },
  props: {
    title: {
      type: String,
      default: 'title'
    },
    content: {
      type: String,
      default: 'content'
    },
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    switchText () {
      return this.value ? this.$t('message["1466"]') : this.$t('message["1459"]')
    }
  },
  methods: {
    onChange (value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style scoped lang="scss">
.config_switch {
  position: relative;
  height: 80px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  .switch_tip {
    margin: 16px;
    display: inline-block;
    line-height: 24px;
    h2 {
      font-weight: 600;
    }
    p {
      color: #666
    }
  }
  .switch_main {
    position: absolute;
    right: 17px;
    top: 27px;
  }
}
</style>
